import React from 'react'
import Landing from './landing.js'

const LandingPage = () => {

    return (
        <>
            <Landing/>
        </>
        
    )
}

export default LandingPage